<template lang="html">
  <div class="patient-list-row">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{$t('patient_list')}}</h3>
            
          </div>
           
          <!-- /.box-header -->
          <div class="box-body no-padding table-responsive">
       
          <div class="input-group">
              <input v-model="form.name" type="text" :placeholder="`${$t('name')}`" class="input-group-text ">
              <input v-model="form.address"  type="text" :placeholder="`${$t('address')}`" class="input-group-text ">
              <input v-model="form.contactNumber"  type="text" :placeholder="`${$t('contactNumber')}`" class="input-group-text ">

                <select v-model="form.gender" class="input-group-select">
                  <option value="">{{$t('gender')}}</option>
                 <option v-for="(s, i) in $t('sex')" :key="i" :value="i">
                           {{s}}
                          </option>
                </select>
              
             <select v-model="form.weight" class="input-group-select">
                  <option value="">{{$t('weight')}}</option>
                 <option v-for="(w, i) in $t('weightData')" :key="i" :value="i">
                           {{w}}
                          </option>
                </select>
                 <select v-model="form.condition" class="input-group-select">
                  <option value="">{{$t('condition')}}</option>
                 <option v-for="(w, i) in $t('conditionData')" :key="i" :value="i">
                           {{w}}
                          </option>
                </select>
            <select v-model="form.status" class="input-group-select">
                  <option value="">{{$t('status')}}</option>
                 <option v-for="(w, i) in $t('statusData')" :key="i" :value="i">
                           {{w}}
                          </option>
                </select>
               <select v-model="form.riskFactor" class="input-group-select">
                  <option value="">{{$t('riskFactorLbl')}}</option>
                 <option v-for="(w, i) in $t('riskFactor')" :key="i" :value="i">
                           {{w}}
                          </option>
                </select>
               <select v-model="form.currentRating" class="input-group-select">
                  <option value="">{{$t('symptom')}}</option>
                 <option v-for="(w, i) in $t('riskFactor')" :key="i" :value="i">
                           {{w}}
                          </option>
                </select>
                <select v-model="form.trend" class="input-group-select">
                  <option value="">{{$t('trend')}}</option>
                 <option v-for="(w, i) in $t('trendData')" :key="i" :value="i">
                           {{w}}
                          </option>
                </select>
             <div class='inlineDiv'>
                 <input type="text" :placeholder="`${$t('ageFrom')}`" class="input-group-text-small" v-model="form.age1"> 
                 <input type="text" :placeholder="`${$t('ageTo')}`" class="input-group-text-small " v-model="form.age2">
              </div>

             <button class='btn btn-sm btn-success padding5' @click="searchClick">{{$t('search')}}</button>
              <button class='btn btn-sm btn-success padding5' @click="clearClick">{{$t('clear')}}</button>
          </div>
       
            <table class="table table-striped">
                    <tbody>
                        <tr>
                        <th style="width: 10px">#</th>
                        <th>{{ $t('name') }}</th>
                        <th>{{ $t('age') }} / {{ $t('gender') }}</th>
                        <th style="width: 40px">{{ $t('address') }} </th>
                        <th style="width: 40px">{{ $t('weight') }}/{{ $t('height') }} </th>
                        <th>{{ $t('contactNumber') }} </th>
                        <th>{{ $t('status') }} </th>
                        <th>{{ $t('risk') }} </th>
                        <th>{{ $t('symptom') }} </th>
                        <th>{{ $t('trend') }} </th>
                        <th>{{ $t('registerDate') }} </th>
                        <th>{{ $t('lastUpdate') }} </th>
                        </tr>
            <tr v-for="pateint in patients">
                 <td></td>
                <td><a :href="`/patient-details?id=${pateint.id}`">{{ pateint.name }}</a></td>
                <td>{{ pateint.age }} {{ $t('sex')[[pateint.gender]] }} </td>
                <td>{{ pateint.address }} {{ pateint.city }}</td>
                <td>{{ $t('weightData')[[pateint.wight]] }} /{{ $t('heightData')[[pateint.height]] }}</td>
                <td>{{ pateint.contactNumber }} , {{ pateint.enterBy!= pateint.contactNumber ? pateint.enterBy:''}}</td>
                <td>{{ $t('statusData')[[pateint.status]] }}</td>
                <td>{{ $t('riskFactor')[[calRiskFactor_(pateint.riskFactor)]] }}</td>
                <td>{{ $t('riskFactor')[[calSymptom_(pateint.currentRating)]] }}</td>
                <td><span v-html="showTrend_(pateint.trend)"></span></td>
                <td>{{ moment(pateint.insertTime).startOf('hour').fromNow()   }}</td>
                <td>{{ pateint.updateTime>0 ? moment(pateint.updateTime).startOf('hour').fromNow():'Never'}}</td>
            </tr>
            </tbody>
            </table>
            <div class="card-footer pb-0 pt-3">
            <simple-pagination :currentpage="form.page" :pages="form.totalpages" @changePage="pageChange"></simple-pagination>
           </div>
        </div>
    </div>
  </div>
</template>

<script>
  import { services } from '../../src/vuex/api'
  import { calRiskFactor ,calSymptom , showTrend } from '../../src/lib/functions'
  import { mapActions , mapGetters } from 'vuex'
  import simplePagination from '../../src/components/simple-pagination'
  export default {
    
    name: 'patient-list-row',
    mounted: function () {
      var self = this
      let uri = window.location.href.split('?')
      if (uri.length === 2){
      let vars = uri[1].split('&')
      let getVars = {}
      let tmp = ''
      vars.forEach(function(v){
        tmp = v.split('=')
        if ( tmp.length === 2 ) {
          getVars[tmp[0]] = tmp[1]
          if ( tmp[0] in self.form ){
            self.form[tmp[0]] = tmp[1]
           }
         }
       })
      }
      this.getPatient(self.form)
      this.getLanguage()
      if ( localStorage.getItem('lan') != null ) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language
      console.log('mounted: got here')
    },
    data: function () {
      return {
        message: 'Patient List Row',
        patients: [],
        form:{
          name:'',
          address:'',
          contactNumber:'',
          gender:'',
          weight:'',
          status:'',
          condition:'',
          age1:'',
          age2:'',
          riskFactor:null,
          trend:null,
          currentRating:null,
          totalpages:0,
          page:0

        },
        customLabels:{
          first: '<<',
          last: '>>',
          previous: '<',
          next: '>'
        }
      }
    },
    components: {
    'simple-pagination': simplePagination
     },
    methods: 
    {
      calRiskFactor_: function(val){
       return calRiskFactor(val)
     },
      calSymptom_: function(val){
       return calSymptom(val)
     },
     showTrend_: function(val){
       return showTrend(val)
     },
       ...mapActions([
      'getLanguage'

    ]
       ),
    
  getPatient: function ( request = {} ) {
    var self = this
     services.patients.getPatientInfo(request) //  .getPatientInfo()
    .then(function (response) {
      // console.log(JSON.stringify(response.data))
      self.patients = response.data.docs
      self.form.totalpages = Math.ceil( response.data.count / response.data.perpage )
      self.form.page = response.data.page
      console.log(response.data.count)
    })
    .catch(function (error) {
      console.log(error)
    })
  },
  searchClick: function (){
    this.getPatient(this.form)
  },
  clearClick: function (){
    var self = this // you need this because *this* will refer to Object.keys below`
        // Iterate through each object field, key is name of the object field`
      Object.keys(this.form).forEach(function(key,index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page'){
          self.form[key] = ''
        }
      })
  },
  pageChange: function (pageNo) {
    var self = this
    self.form.page = pageNo
    this.getPatient(this.form)
  }
},
 computed: {
    ...mapGetters([
      'lang'
    ])
  }
}
</script>

<style lang="css" scoped>
.input-group{
  width: 100%;
  padding: 20px;
}
.input-group-text,.input-group-select{
  width: 7%;
  margin-left: 5px;
}
.input-group-text-small{
 width: 7%;
}
.inlineDiv{
 display: inline;
}
</style>



// WEBPACK FOOTER //
// PatientList.vue?f906c40c